import { render, staticRenderFns } from "./InputBtn.vue?vue&type=template&id=a144fac2&scoped=true"
import script from "./InputBtn.vue?vue&type=script&lang=js"
export * from "./InputBtn.vue?vue&type=script&lang=js"
import style0 from "./InputBtn.vue?vue&type=style&index=0&id=a144fac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a144fac2",
  null
  
)

export default component.exports